import React from 'react';
import { motion } from 'framer-motion';
import { Landmark, Radio, Droplet, Store, HeartHandshake } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { CTABanner } from '../components/CTABanner';
export function IndustriesPage() {
  const industries = [{
    icon: <Landmark className="w-10 h-10" data-id="element-388" />,
    title: 'Government & Public Sector',
    description: 'We partner with federal and state agencies to modernize public infrastructure. Our solutions enable secure data management, streamline citizen services, and support e-government initiatives while ensuring compliance with national security standards.',
    color: 'from-blue-500 to-blue-700'
  }, {
    icon: <Radio className="w-10 h-10" data-id="element-389" />,
    title: 'Telecommunications',
    description: "Supporting the backbone of Africa's connectivity. We provide robust infrastructure design, network optimization, and managed services to help telcos deliver reliable, high-speed services to their expanding subscriber bases.",
    color: 'from-purple-500 to-purple-700'
  }, {
    icon: <Droplet className="w-10 h-10" data-id="element-390" />,
    title: 'Oil & Gas',
    description: 'Delivering resilient IT and communication solutions for harsh and remote environments. We enable real-time data transmission, predictive maintenance, and secure connectivity between offshore rigs and onshore headquarters.',
    color: 'from-orange-500 to-orange-700'
  }, {
    icon: <Store className="w-10 h-10" data-id="element-391" />,
    title: 'Enterprise & SMEs',
    description: 'Empowering businesses of all sizes to scale efficiently. From setting up secure corporate networks to implementing automated business processes, we provide the technological foundation for commercial growth and competitiveness.',
    color: 'from-green-500 to-green-700'
  }, {
    icon: <HeartHandshake className="w-10 h-10" data-id="element-392" />,
    title: 'Development Agencies',
    description: 'Collaborating with NGOs and international development organizations to drive digital inclusion. We deploy accessible technology solutions in underserved areas to support education, healthcare, and economic empowerment programs.',
    color: 'from-teal-500 to-teal-700'
  }];
  return <main className="w-full pt-20" data-id="element-393">
      {/* Page Header */}
      <section className="bg-navy-900 py-20 relative overflow-hidden" data-id="element-394">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-395" />
        <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-396">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-397">
            Industries We <span className="text-tech-green" data-id="element-398">Serve</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-slate-300 max-w-2xl" data-id="element-399">
            Tailored technology solutions designed to meet the unique
            regulatory, operational, and strategic demands of diverse sectors.
          </motion.p>
        </div>
      </section>

      {/* Industries List */}
      <section className="py-24 bg-slate-50" data-id="element-400">
        <div className="max-w-7xl mx-auto px-4" data-id="element-401">
          <div className="space-y-12" data-id="element-402">
            {industries.map((industry, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-white rounded-3xl overflow-hidden shadow-sm border border-slate-100 flex flex-col md:flex-row group hover:shadow-xl transition-shadow duration-300" data-id="element-403">
                <div className={`md:w-1/3 p-10 flex flex-col items-center justify-center text-center bg-gradient-to-br ${industry.color} text-white relative overflow-hidden`} data-id="element-404">
                  <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-20 mix-blend-overlay" data-id="element-405" />
                  <div className="relative z-10 transform group-hover:scale-110 transition-transform duration-500" data-id="element-406">
                    {industry.icon}
                  </div>
                  <h3 className="text-2xl font-bold mt-6 relative z-10" data-id="element-407">
                    {industry.title}
                  </h3>
                </div>

                <div className="md:w-2/3 p-10 flex items-center" data-id="element-408">
                  <p className="text-lg text-slate-600 leading-relaxed" data-id="element-409">
                    {industry.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTABanner data-id="element-410" />
    </main>;
}